exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/theme/components/modals/components/modalMessageOk/modalMessageOk.scss
// module id = ../../../../../src/app/theme/components/modals/components/modalMessageOk/modalMessageOk.scss
// module chunks = 11